module.exports = __webpack_public_path__ + "static/img/kong-vd.b11ecd8e.png";